import { render, staticRenderFns } from "./AdminNotificationList.vue?vue&type=template&id=4d6df7f5"
import script from "./AdminNotificationList.vue?vue&type=script&lang=js"
export * from "./AdminNotificationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports